var r = Array.isArray,
    t = function t(e) {
  if ("string" == typeof e) return e;
  if ("object" != typeof e) return "";
  var n,
      f = "";
  if (r(e)) for (var o = 0; o < e.length;) {
    (n = t(e[o++])) && (f += (f && " ") + n);
  } else for (n in e) {
    e[n] && n && (f += (f && " ") + n);
  }
  return f;
};

function e() {
  for (var r, e = 0, n = ""; e < arguments.length;) {
    (r = t(arguments[e++])) && (n += (n && " ") + r);
  }

  return n;
}

var n = /\s+/,
    f = Object.create,
    o = Array.isArray;

function i() {}

function a(r, t) {
  var e;
  if (r) if ("string" != typeof r) {
    if ("object" == typeof r) if (o(r)) {
      e = r.length;

      for (var f = 0; f < e; f++) {
        a(r[f], t);
      }
    } else {
      var i;

      for (i in r) {
        t[i] = !!r[i];
      }
    }
  } else {
    e = (r = r.split(n)).length;

    for (var l = 0; l < e; l++) {
      t[r[l]] = !0;
    }
  }
}

function l() {
  for (var r = new i(), t = 0; t < arguments.length;) {
    a(arguments[t++], r);
  }

  var e = "";

  for (t in r) {
    r[t] && t && (e += (e && " ") + t);
  }

  return e;
}

i.prototype = f(null);
export { e as cnb, l as dcnb };